var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import History from "@irati/utils/history";
import Loading from "@irati/ui/src/Loading";
import userService from "@irati/identity/services/users";
import onboardingService from "@irati/onboarding/services/onboarding";
import OnboardingSteps from "@irati/onboarding/enums/Step";
import { hangPromise } from "@irati/utils/promise";
import authentication from "@irati/auth";
import passwordService from "@irati/auth/services/password";
import loginService from "@irati/auth/services/login";
import FormattedMessage from "@irati/utils/lang";
import SetPassword from "../../components/UserOnboarding/SetPassword";
import { getQuery } from "../../helpers/getOnboardingQuery";
var UserOnboarding = /** @class */ (function (_super) {
    __extends(UserOnboarding, _super);
    function UserOnboarding() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            load: hangPromise(),
            user: null
        };
        _this.getUser = function () {
            var uuid = getQuery().uuid;
            return userService.unAuthedUser(uuid).then(function (user) {
                return _this.handleGetOnboarding(user);
            });
        };
        _this.handleGetOnboarding = function (user) {
            return onboardingService.get(user.uuid).then(function (_a) {
                var steps = _a.steps, completedSteps = _a.completedSteps;
                if (completedSteps.includes(OnboardingSteps.SET_PASSWORD)) {
                    History.push({ pathname: "/" });
                }
                _this.setState({ user: user });
                return { steps: steps };
            });
        };
        _this.handleSetPassword = function (password) {
            var code = getQuery().code;
            var user = _this.state.user;
            return passwordService.setForgot(user.uuid, code, password).then(function () {
                return loginService.login(authentication.unAuthedBusiness(), user.email, password).then(function () {
                    return onboardingService.completeStep(user, OnboardingSteps.SET_PASSWORD).then(function () {
                        return _this.handleGetOnboarding(user);
                    });
                });
            });
        };
        return _this;
    }
    UserOnboarding.prototype.componentDidMount = function () {
        var _this = this;
        this.setState({
            load: loginService.logout().then(function () { return _this.getUser(); })
        });
    };
    UserOnboarding.prototype.render = function () {
        var _a = this.state, load = _a.load, user = _a.user;
        var header = React.createElement(FormattedMessage, { id: "onboarding.validateDetails.data.header1", values: { firstname: user === null || user === void 0 ? void 0 : user.firstName } });
        return (React.createElement(Loading, { load: load },
            React.createElement(SetPassword, { user: user, onComplete: this.handleSetPassword, header: header })));
    };
    return UserOnboarding;
}(Component));
export default UserOnboarding;
